import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {QualifiedForIncentiveTripContent} from './QualifiedForIncentiveTripContent';
import reportPayload from './reportPayload';

export const QualifiedForIncentiveTripReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Qualified for Incentive Trip 2024')}
      description={tt(
        'description',
        'These Coaches have completed all of the requirements and qualified for the Incentive Trip 2024. ',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={QualifiedForIncentiveTripContent}
    />
  );
};

export default withHOC(
  withTranslation('report.qualifiedForIncentiveTripReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP,
    popoverContentProps: {},
  }),
)(QualifiedForIncentiveTripReport);
